<div class="app-container" [class.logged-out]="!loggedIn()">
	@if (!authInitialized()) {
		<mat-spinner></mat-spinner>
	} @else if (loggedIn()) {
		<app-header
			[isMobile]="isMobile"
			(menuClick)="sidenav.toggle()">
		</app-header>
		<mat-sidenav-container class="sidenav-container">
			<mat-sidenav
				#sidenav
				[mode]="isMobile ? 'push' : 'side'"
				[opened]="!isMobile"
				[fixedInViewport]="true"
				[fixedTopGap]="headerHeight"
				[disableClose]="!isMobile"
				(click)="sidenav.mode === 'side' || sidenav.close()">
				<app-sidenav></app-sidenav>
			</mat-sidenav>
			<mat-sidenav-content class="sidenav-content">
				<main class="main-content">
					<router-outlet></router-outlet>
				</main>
			</mat-sidenav-content>
		</mat-sidenav-container>
	} @else {
		<app-header
			[isMobile]="isMobile"
		>
		</app-header>
		<router-outlet></router-outlet>
	}
</div>
